module.exports = __webpack_public_path__ + "img/slide-3-xl.a7bc65b.webp";